"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToReceiverMatchups = void 0;
function mapToReceiverMatchups(response, player) {
    let grade = undefined;
    if (response.facet != null &&
        response.gradeValue != null &&
        response.gradeRank != null &&
        response.gradeRankTotal != null) {
        grade = {
            rank: response.gradeRank,
            totalRank: response.gradeRankTotal,
            grade: response.gradeValue,
            facet: response.facet,
        };
    }
    return {
        cornerback: player,
        expectedSnapCount: response.expectedSnapCount,
        grade: grade,
        score: response.matchupScore,
    };
}
exports.mapToReceiverMatchups = mapToReceiverMatchups;
//# sourceMappingURL=wr_cb_request.js.map